/** @jsx jsx */
import PropTypes from "prop-types"
import { jsx } from "theme-ui"

const ImageLink = ({ url, imageUrl, altText }) => {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img
        alt={altText}
        src={imageUrl}
        sx={{
          height: "45px",
          width: "auto",
        }}
      />
    </a>
  )
}

ImageLink.propTypes = {
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  altText: PropTypes.string.isRequired,
}

export default ImageLink
